import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import axios from '../tokenInterceptor';
import PlaySongs from "./PlaySongs";

class SearchSong extends Component {
    constructor(props) {
        super(props);
        this.state={
            selectedMusic:{},
            tracks:[]
        }
    }

    componentWillMount () {
        if(this.props.match.params!='' || this.props.match.params !=null) {
            this.getSelectedSong(this.props.match.params.name);
        } else {
        }
    }

    componentWillReceiveProps(props) {
        if(props.match.params!='' || props.match.params !=null) {
            this.getSelectedSong(props.match.params.name);
        } else {
        }
    }

    getSelectedSong =(search)=>{
        let basicToken  = localStorage.getItem("auth-token");
        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': basicToken
            }
        };
        axios.get("/getSelectedSong",{
            params: {
                searchKey: search
            }
        }, config).then((res)=>{
            if(res.status == 200) {
                let td = res.data.data.trackDefinitions;
                let num = Object.keys(td).length;
                let tracksContents =[]
                for(let i=0; i<num; i++) {
                    let key = "catalog_tracks_search_track_def_"+i;
                    let data = td[key];
                    tracksContents.push(data);
                };
                this.setState({tracks:tracksContents});    
            } else {
                this.setState({tracks:[]});
            }
        })
    }

    setMusic=(data)=>{
        let selectedMusic= this.state.selectedMusic;
        selectedMusic.title = data.title;
        selectedMusic.artist = data.artist.name;
        selectedMusic.imageUrl = data.image.uri;
        selectedMusic.songUrl = data.audio.uri;
        this.setState({selectedMusic:selectedMusic});
    }



    render() {
        return (
            <>
                <div className="right-section">
                    <div className="main-page">
                        <div className="top-alternative">
                            <ul>
                                {this.state.tracks.map((data, index)=>{
                                    return <li key={index} className="song-title">
                                        <img src={data.image.uri} style={{"width":"50px", "height":"50px"}}/>
                                        <a className="title" style={{"cursor": "pointer"}} onClick={()=>this.setMusic(data)}>{data.title}</a>
                                    </li>
                                })}
                            </ul>
                        </div>
                        <PlaySongs
                            music={this.state.selectedMusic}
                        />
                    </div>
                    
                    
                </div>
            </>
        )
    }
}

export default SearchSong;
